const PARQUE_CERRADO = "parque-cerrado";
let PARQUE_ABIERTO = "parque-abierto";
const LABEL_CERRADO = "Parque Cerrado";
const LABEL_ABIERTO = "parque abierto";
let LABEL_DISPONIBLE = "pasaporte disponible";
const LABEL_NO_DISPONIBLE = "pasaporte no disponible";
const PASAPORTE_NO_DISPONIBLE = "sin-pasporte";
const FORMATO_FECHA_CALENDARIO = "m/d/yy";
const MAXIMO_FECHAS_MOSTRAR = new Date(new Date().getFullYear() + 1, 11, 31); // Hasta el 31 de diciembre de este año
//const MAXIMO_FECHAS_MOSTRAR = new Date(new Date().getFullYear() + 1, 11, 31); // Hasta el 31 de diciembre del próximo año
let fechasDeshabilitadas = [];
let fechasPasaporte = [];
let colorPasaporte = "#B7B7B7";
let isOpen=false;

const UrlsPasaporte ={

  FECHAS_TRAVESIA : "https://grupopanaca.com.co/webapi/api/travesiashow",
 // FECHAS_NATURA : "https://grupopanaca.com.co/webapi/api/NaturaFechas",
 // FECHAS_GRANJERO : "https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=119",
  FECHAS_TERRA : "https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=101",
 
  
}

const ClasesPasaporte={

     ABIERTO:"parque-abierto",
     TRAVESIA :"pasaporte-travesia",
     NATURA : "pasaporte-natura",
     TERRA : "pasaporte-terra",
     TERRA_NINO : "pasaporte-terra-nino",
     GRANJERO : "pasaporte-granjero",
     CAMPO:    "pasaporte-campo",
     TERRA_NATURA :"pasaporte-natura",
}

const IdsPasaportes={
  ABIERTO:"8561612685531a",
  TERRA: "8561612685531",
  TRAVESIA: "8561613471963",
  NATURA  : "8561616388315",
  GRANJERO : "8680180711643",
  INFANTIL :  "8675970285787",
  CAMPO : "8561615274203",
  CAMPOINFANTIL : "8752678502619",
  TERRA_NATURA : "8561617535195",
  
}

const ColorPasaporte={
    TERRA:"#116736",
    TERRA_NINO : "#EC890A",
    NATURA : "#116736",
    TRAVESIA : "#AC6B3A",
    GRANJERO : "#E2725B",
    ABIERTO: "#FFF",
}

const Pasaportes ={

    ABIERTO:"Parque Abierto",
    TERRA :"Pasaporte Terra",
    TERRA_NINO :"Pasaporte Terra Niño",
    NATURA : "Pasaporte Natura",
    TRAVESIA : "Pasaporte Travesía",
    GRANJERO : "Pasaporte Granjero",
    CAMPO : "Pasaporte Campo",
    TERRA_NATURA : "Pasaporte Terra + Natura",
}

function formatearFecha(fecha) {
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
  
}

async function  diaCerrado() {
  fechasDeshabilitadas=[];
  try{ 
    const respuesta = await fetch('https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=101');
    const json = await respuesta.json();
   
    const fechasConvertidas = json.map((item) => {
        if (item.Fecha) {
            const [mes, dia, anio] = item.Fecha.split('/');
            return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        } else {
          return null; 
       }
      
  });
  
  fechasDeshabilitadas = [...fechasConvertidas ];
  
  }catch(error){
    console.log("ocurrio el siguiente error", error);
  }
}

function  ocultarModal() {

  const modal = document.querySelector("#myModal");
  let select = document.querySelector(".contenedor-eventos__select").value;
  let prueba = document.querySelector(`#pspt${select}`);
  ocultarChat();
  modal.style.display = 'none';
}

function verificarDisponibilidad(date) {
  
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0); 

    const formattedDate = formatearFecha(date);

    if (date < fechaActual) {
        return [true, 'fecha-anterior', 'Fecha Anterior'];
    }

    
    if (fechasDeshabilitadas.includes(formattedDate)) {
        return [false, PARQUE_CERRADO, LABEL_CERRADO]; 
    } else {
        return [true, PARQUE_ABIERTO, LABEL_ABIERTO]; 
    }
}




function fechaEnRangoPromo(fechaStr) {
  // fechaStr debe ser algo parseable por Date (ideal: "YYYY-MM-DD")
  const fecha = new Date(fechaStr);

  // Si no se pudo parsear, no aplica promo
  if (isNaN(fecha.getTime())) return false;

  const year = fecha.getFullYear();
  const inicio = new Date(year, 1, 19); // 19 Feb (mes 1)
  const fin = new Date(year, 2, 19, 23, 59, 59); // 19 Mar

  return fecha >= inicio && fecha <= fin;
}

function mostrarMensajePromoSiAplica(dateText) {
  const section = document.querySelector(".section-pasaportes");
  if (!section) return;

  const idMensaje = "promo-campanapag-msg";
  let msg = section.querySelector(`#${idMensaje}`);

  const aplica = fechaEnRangoPromo(dateText);

  if (aplica) {
    if (!msg) {
      msg = document.createElement("p");
      msg.id = idMensaje;
      msg.className = "section-pasaportes__promo-msg"; // por si quieres estilizar
      section.prepend(msg); // o appendChild si lo quieres al final
    }

    msg.textContent =
      "Aprovecha 50% de descuento más 10% adicional por comprar en línea. Válido del 19 de febrero al 19 de marzo.";
  } else {
    // Si ya existe y ya no aplica, lo removemos
    if (msg) msg.remove();
  }
}

function eventosCalendario(dateText, inst) {
  const pasaportes = document.querySelectorAll(".section-pasaportes__slide-card");
  const fechaVisita = document.querySelector(".section-pasaportes__titulo-principal");

  pasaportes.forEach((pasaporte) => pasaporte.setAttribute("data-fecha", dateText));

  validarPasaportes(dateText);
  fechaVisita.textContent = obtnerFechaLarga(dateText);

  const promoActiva = fechaEnRangoPromo(dateText);
 
  // Texto promo
  mostrarMensajePromoSiAplica(dateText);

  // Precios promo
  applyPromoReplacements(promoActiva, PROMO_PRICE_REPLACEMENTS);

  ocultarModal();
  validationPassport();
}




// 👇 Aquí pones TODOS los IDs que quieras cambiar y el valor nuevo
const PROMO_PRICE_REPLACEMENTS = [
  { id: "price-compare-of-8561612685531", value: "$60.000,00" },
  { id: "price-compare-of-8561613471963", value: "$35.000,00" },
  { id: "price-compare-of-8675970285787", value: "$42.500,00" },
  { id: "price-compare-of-8561615274203", value: "$87.500,00" },
  { id: "price-compare-of-8752678502619", value: "$70.000,00" },
];

function fechaEnRangoPromo(fechaStr) {
  // Ideal: fechaStr tipo "YYYY-MM-DD"
  const fecha = new Date(fechaStr);
  if (isNaN(fecha.getTime())) return false;

  const year = fecha.getFullYear();
  const inicio = new Date(year, 1, 19); // 19 Feb
  const fin = new Date(year, 2, 19, 23, 59, 59); // 19 Mar 23:59:59

  return fecha >= inicio && fecha <= fin;
}

function applyPromoReplacements(isPromoActive, replacements) {
  replacements.forEach(({ id, value }) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Guardar original una sola vez
    if (!el.dataset.originalText) {
      el.dataset.originalText = el.textContent.trim();
    }

    if (isPromoActive) {
      el.textContent = value;
      el.classList.add("promo-active"); // opcional para estilos
    } else {
      el.textContent = el.dataset.originalText;
      el.classList.remove("promo-active");
    }
  });
}




function configuracionesCalendario(){
  return{
      dateFormat: FORMATO_FECHA_CALENDARIO,
      changeMonth: true,     
      changeYear: true,       
      minDate: new Date(),    
      maxDate: MAXIMO_FECHAS_MOSTRAR,
      beforeShowDay:verificarDisponibilidad,
      onSelect:eventosCalendario,
      language: 'es'
  }
}

async function inicializarDatepicker() {
    await diaCerrado();
    let configuraciones = await configuracionesCalendario();
    $("#datepicker").datepicker(configuraciones);
}

async function obtenerFechas(url){

    try{
       const respuesta = await fetch(url);

      if(!respuesta.ok){
        if (respuesta.status === 404) {
              throw new Error('404 Not Found');
        } else {
           throw new Error(`Error: ${respuesta.status} ${respuesta.statusText}`);
        }

      }
       const json = await respuesta.json();
     console.log(json)
     console.log(json[0])
     console.log(json[0].Fecha)
       return json;
      
    }catch(error){
       console.log("ocurrio el siguiete error", error.message);
      return   '404 Not Found';
    }
    
  }

async function validarPasaportes(fecha){
  
   // await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_NATURA,  IdsPasaportes.NATURA);
   // await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_NATURA, IdsPasaportes.TERRA_NATURA);
   
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.TRAVESIA);
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.CAMPOINFANTIL);
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.CAMPO);
 

  }

function obtnerFechaLarga(fecha){
  
  const fechaLarg = new Date(fecha);
  
  const opciones = { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric'
  };

  const fechaFormateada = fechaLarg.toLocaleDateString('es-ES', opciones);
  
  return fechaFormateada;
}

async function validarFechasDisponibilidadPasaporte(fecha, Urlfechas, idcontendorPasaporte){

  fecha = fecha.replaceAll("-", "/");

  const fechaPasaporte = await obtenerFechas(Urlfechas);
  const contenedorPasporte = document.getElementById(`pspt_${idcontendorPasaporte}`);
  const pasaporteSlideMovil = document.querySelector(".slide-activo");
  let fechaValida = await  fechaPasaporte.find((item)=>item.Fecha == fecha); 

    
   if(!fechaValida){
       contenedorPasporte.style.setProperty('display', "none");
    }else{
        contenedorPasporte.style.setProperty('display', "flex");
    }

 
  if (window.innerWidth < 480) {
    if (pasaporteSlideMovil) {
        //contenedorPasporte.style.setProperty('display', 'none');
        return;
      } 
  }
 popaup();
  
}

function cargarCalendario() {
  ;
  document.addEventListener('DOMContentLoaded', ()=>{
     const modal = document.querySelector('.modal');
    modal.style.setProperty('display', 'flex');
    // inicializarDatepicker();
  });
}

async function fechasDisponibilidadPasaporte(idpasaporte){

  const nomenclatura = document.querySelector(".color-nomenclatura__cerrado");
  const nomenclaturaSinpasaporte = document.querySelectorAll(".color-nomenclatura__cerrado");
  const nombrePasaporte = document.querySelector(".etiqueta-nomenclatura");
  const diaSinPasporte = document.querySelector(".color-nomenclatura__abierto");

  const nomenclaturaCerrado = document.querySelector(".fila_nomeclatur_cerrar");
  const PasaporteNoDisponible = document.querySelectorAll(".etiqueta-nomenclatura");
  PasaporteNoDisponible[1].textContent =LABEL_CERRADO;

  const nomenClaturaOculta = document.querySelector(".fila-nomenclatura__oculto");
  
  
  nomenclatura.style.setProperty("background-color", "#fff");
  diaSinPasporte.style.setProperty("background-color", "red");
  fechasDeshabilitadas = [];
  fechasPasaporte = [];
  let fechas = "";
  let isTerra=false;
  


   switch(idpasaporte){
      
     
     case  IdsPasaportes.TRAVESIA:
          fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TRAVESIA);

           let etiqueta =  nombrePasaporte.parentNode.firstElementChild;
           etiqueta.style.setProperty('background-image', 'url("https://cdn.shopify.com/s/files/1/0607/8726/1659/files/miniatura_cb095494-adc7-4c31-936b-db899c0015df.png")');
           etiqueta.style.setProperty("width", "50px");
           etiqueta.style.setProperty("height", "40px");
           etiqueta.style.setProperty("background-repeat", "no-repeat");
           etiqueta.classList.add("logo-travesia");
           etiqueta.style.setProperty("border", "none");
           nombrePasaporte.style.setProperty("margin-top", "15px");
            nombrePasaporte.textContent= "Travesia 2.0";
           colorPasaporte = ClasesPasaporte.TRAVESIA;
         
           nomenClaturaOculta.style.setProperty("opacity", 1);
            LABEL_DISPONIBLE = Pasaportes.TRAVESIA;
      
          
       break
    case IdsPasaportes.ABIERTO:
        fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TERRA );
         nomenclatura.style.setProperty("background-color",  ColorPasaporte.ABIERTO);
         colorPasaporte = ClasesPasaporte.ABIERTO;
       PARQUE_ABIERTO = "parque-abierto";
         isTerra=true;
         isOpen=true;
         LABEL_DISPONIBLE = Pasaportes.ABIERTO;
       
         nomenClaturaOculta.style.setProperty("opacity", 0);
      
       break;
       
     default:
       
         fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TERRA);
         nombrePasaporte.textContent = Pasaportes.TERRA;
         nomenclatura.style.setProperty("background-color",  ColorPasaporte.TERRA);
         colorPasaporte = ClasesPasaporte.TERRA;
         PARQUE_ABIERTO = "pasaporte-terra";
         isTerra=true;       
         diaSinPasporte.style.setProperty("background-color", "red");                
         nomenClaturaOculta.style.setProperty("opacity", 0);
       break;
       
   }


  let fechasConvertidas = await formatoFehcaMesDiaAnio(fechas)
  fechasDeshabilitadas = [...fechasConvertidas ];
 
  fechasPasaporte  = [...fechasConvertidas ];
  renderizarCalendario(isTerra);

}

function formatoFehcaMesDiaAnio(fechas) {
 
   return fechas.map((item) => {
        if (item.Fecha) {
          console.log(item.Fecha)
            const [mes, dia, anio] = item.Fecha.split('/');
            return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        } else {
          return null; 
       }
      
  });
}

function fechasNodisponible(date) {

  const fechaActual = new Date();
  fechaActual.setHours(0, 0, 0, 0); 
  const formattedDate = formatearFecha(date);

  
 if (fechasDeshabilitadas.includes(formattedDate)) {
        return [false, PARQUE_CERRADO, LABEL_CERRADO]; 
    }

    // Verificar si la fecha es anterior a la actual
    if (date < fechaActual) {
        return [true, 'fecha-anterior', 'Fecha Anterior']; 
    }

    
    const esFechaPermitida = fechasPasaporte.some(fecha => {
        let arrayfecha = fecha.split("-");
        let anio = parseInt(arrayfecha[0], 10);
        let mes = parseInt(arrayfecha[1], 10) - 1; 
        let dia = parseInt(arrayfecha[2], 10);

       
        return date.getDate() === dia &&
               date.getMonth() === mes &&
               date.getFullYear() === anio;
    });

  
    return esFechaPermitida
        ? [true, colorPasaporte, LABEL_DISPONIBLE]  
        : [true, PASAPORTE_NO_DISPONIBLE,  LABEL_ABIERTO]; 
}

async function esFechaEnArray(date, arrayFechas) {
    return arrayFechas.some(fecha => {
        let arrayFecha = fecha.split("-");
        let anio = parseInt(arrayFecha[0], 10);
        let mes = parseInt(arrayFecha[1], 10) - 1; // Mes en base 0
        let dia = parseInt(arrayFecha[2], 10);

        return date.getDate() === dia &&
               date.getMonth() === mes &&
               date.getFullYear() === anio;
    });
}

async function renderizarCalendario(terra){

  let agregarClases = "";
  
  if(terra){
      agregarClases =await  verificarDisponibilidad;
  
    }else{
      await diaCerrado();
      agregarClases = await fechasNodisponible;
    }

     $('#datepicker').datepicker('destroy');
     $('#datepicker').datepicker({
          dateFormat: FORMATO_FECHA_CALENDARIO,
          changeMonth: true,     
          changeYear: true,       
          language: 'es',  
          minDate: new Date(),    
          maxDate: MAXIMO_FECHAS_MOSTRAR,
          beforeShowDay: agregarClases,
          onSelect:eventosCalendario,
      });
  
}

function clicksCalendarioPasaportes(){
  document.addEventListener('change', (event)=>{
    switch(true){
      case event.target.matches('.contenedor-eventos__select'):
         //fechasDisponibilidadPasaporte(IdsPasaportes.TERRA);
        fechasDisponibilidadPasaporte(event.target.value);
        break;

      
    }
  });
}

function clicsksDocument(){
   document.addEventListener('click', (event)=>{
    switch(true){
      case event.target.matches('.buttonCompraAhoraHeader, .section-pasaportes__redirecion'):   
        location.reload();
        break;

      
    }
  });
}

function ocultarChat() {
 var chatButton = document.querySelector("button.chat-toggle.chat-toggle--icon-button");
    if (chatButton) {
        chatButton.style.display = "none";
       
    }
}

function closeTextModal(){
  window.location.href = "https://panaca.co"
}

document.addEventListener("click",(e)=>{
  if(e.target.className == "modal"){
 
  }
})

function popaup(){
/*

  const select = document.querySelector(".contenedor-eventos__select").value;
  if(select ==IdsPasaportes.TERRA || select ==IdsPasaportes.ABIERTO){
   Swal.fire({
            title: 'ESTÁS A UN CLIC DE VIVIR UNA EXPERIENCIA DE DIVERSIÓN COMPLETA EN PANACA',
            html: `Por tu compra entras a PANACA con el Pasaporte Terra y disfruta gratis del espectáculo Travesía. Recuerda que esta promoción es válida en las siguientes fechas:<br><br>
                    <b> Noviembre:</b>19, 21, 23, 26, 28 y 30 <br>
                    <b> Diciembre:</b>3, 5, 10, 11, 12, 13, 14, 15, 17, 18, 19, 20, 21 y 22.<br><br>
                    ¡Te esperamos!<br><br>                                  
                    <b><a target="blank_" href="https://panaca.co/pages/terminos-y-condiciones-pasaporte-terra-travesia"> *Aplican términos y condiciones.</a></b>` 
   });
  }
*/
}

clicksCalendarioPasaportes();
cargarCalendario();
clicsksDocument();
inicializarDatepicker();
fechasDisponibilidadPasaporte("8561613471963");